import { styled as muiStyled } from "@mui/material/styles";
import Popover from '@mui/material/Popover';

const WidthArrowPopover = muiStyled(Popover)(({theme})=> ({
  marginTop: "10px",
  overflow: "visible",
  '& .MuiPopover-paper': {
    boxShadow: theme.shadows[4],
    overflow: 'visible',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: "-8px", // 调整箭头位置
      left: '50%', // 调整箭头位置
      transform: 'translateX(-50%)',
      width: 0,
      height: 0,
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderBottom: `8px solid ${theme.palette.background.paper}`,
      // boxShadow: 'var(--mui-shadows-8)' // 可选阴影
      filter: 'drop-shadow(0px -1px 1px rgba(0,0,0,0.12))'
    }
  }
}));

export default WidthArrowPopover;